import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  Popover,
  Button,
  ButtonGroup,
  TextField
} from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import {
  preFormatForm,
  validateForm,
  TextCellConstraints
} from '@nile/components';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
  .mw200 {
    max-width: 200px;
  }
  padding-right: 8px;
  max-width: 100%;
`;

const TextCell = (props) => {
  const { className } = props;
  const editable = props?.editable || false;
  const displayVal = props?.value || 'NA';
  const [popoverActive, setPopoverActive] = useState(false);
  const [errors, setErrors] = useState(null);
  const [currentVal, setCurrentVal] = useState(props?.value || '');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const handleChange = useCallback((val) => {
    setCurrentVal(val);
  });

  const onSaveAction = () => {
    const dummyForm = preFormatForm({ name: currentVal });
    const validationResult = validateForm(dummyForm, TextCellConstraints);
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);
    props.handleUpdate(props.property, currentVal);
    togglePopoverActive();
  };

  const onCancelAction = () => {
    togglePopoverActive();
  };

  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div title={displayVal}>
        {displayVal ? (
          <div className={`title name mr8 ${className || ''}`}>
            {displayVal}
          </div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div title={displayVal}>
        {displayVal ? (
          <div className="title name mr8">{displayVal}</div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        <Field>
          <TextField
            onChange={handleChange}
            value={currentVal}
            error={errors?.name}
          />
          <div className='className="mt10"'>
            <ButtonGroup>
              <Button onClick={onCancelAction}>Cancel</Button>
              <Button primary id={'genTextCellSave'} onClick={onSaveAction}>
                Save
              </Button>
            </ButtonGroup>
          </div>
        </Field>
      </Popover>
    </Wrap>
  );
};

export default TextCell;
